import { Controller } from "@hotwired/stimulus"

const OPEN = "grid-rows-[1fr]"
const CLOSED = "grid-rows-[0fr]"
const ROTATED = "rotate-180"

export default class extends Controller {
  static targets = ["content", "icon", "overflow"]

  get isOpen() {
    return this.contentTarget.classList.contains(OPEN)
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.#closeSiblings()
      this.open()
    }
  }

  open() {
    this.contentTarget.classList.replace(CLOSED, OPEN)
    this.iconTarget.classList.add(ROTATED)
    this.dispatch("opened")
  }

  close() {
    if (!this.isOpen) return
    this.#clipOverflow()
    this.contentTarget.classList.replace(OPEN, CLOSED)
    this.iconTarget.classList.remove(ROTATED)
  }

  onTransitionEnd(event) {
    if (event.target !== this.contentTarget) return
    if (event.propertyName !== "grid-template-rows") return
    if (this.isOpen) this.#unclipOverflow()
  }

  #unclipOverflow() {
    if (this.hasOverflowTarget) {
      this.overflowTarget.classList.replace("overflow-hidden", "overflow-visible")
    }
  }

  #clipOverflow() {
    if (this.hasOverflowTarget) {
      this.overflowTarget.classList.replace("overflow-visible", "overflow-hidden")
    }
  }

  #closeSiblings() {
    document.querySelectorAll('[data-controller~="accordion"]').forEach(el => {
      if (el === this.element) return
      const sibling = this.application.getControllerForElementAndIdentifier(el, "accordion")
      if (sibling) sibling.close()
    })
  }
}
